











































































// Vue
import { Component, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { Mixins } from "vue-mixin-decorator";
// Components
import Icon, { IconEnum } from "@/shared/components/icon.component.vue";
import SearchAutocomplete from "@/shared/components/SearchAutocomplete.component.vue";
import CheckIcon, {
  CheckIconColor
} from "@/shared/components/CheckIcon.component.vue";
import ExpansionPanel from "@/shared/components/expansion.panel.component.vue";
// Mixins
import SearchMixin from "@/shared/mixins/search.mixin.ts";
// Models
import {
  TypeOfPrice,
  TypeOfProduct
} from "@/manager/product/models/product.model";

@Component({
  components: {
    Icon,
    SearchAutocomplete,
    CheckIcon,
    ExpansionPanel
  },
  computed: {
    ...mapGetters({
      clientList: "getClientList",
      getClient: "getClient",
      currentPurchase: "getCurrentPurchase",
      hasPreviousPurchases: "hasPurchases",
      previousPurchaseIsCanceled: "previousPurchaseIsCanceled",
      purchaseFinished: "currentPurchaseFinished",
      clientSelected: "currentPurchaseHasClient"
    })
  }
})
export default class SaleInfoViewSpecialOption extends Mixins<SearchMixin>(
  SearchMixin
) {
  @Prop() private clientSelectedTags!: Array<any>;
  @Prop() private convocation!: any;
  private getClient!: any;
  private clientList!: any;
  private clientSelected!: any;
  private hasPreviousPurchases!: any;
  private previousPurchaseIsCanceled!: any;
  private purchaseFinished!: any;
  private currentPurchase!: any;
  private checkIconColor = CheckIconColor;
  private iconEnum = IconEnum;

  private useBonoPrice = {
    text: "Precio B. Recom (N1)",
    model: false,
    typeOfPrice: TypeOfPrice.Bono,
    show: 'showBono'
  };
  private commonTypeOfPrices = {
    use_price1: {
      text: "Precio 1",
      model: false,
      typeOfPrice: TypeOfPrice.Price1,
      show: 'showPrice1'
    },
    use_price2: {
      text: "Precio 2",
      model: false,
      typeOfPrice: TypeOfPrice.Price2,
      show: 'showPrice2'
    },
    use_price3: {
      text: "Precio 3",
      model: false,
      typeOfPrice: TypeOfPrice.Price3,
      show: 'showPrice3'
    },
    use_price4: {
      text: "Precio 4",
      model: false,
      typeOfPrice: TypeOfPrice.Price4,
      show: 'showPrice4'
    },
    use_price5: {
      text: "Precio 5",
      model: false,
      typeOfPrice: TypeOfPrice.Price5,
      show: 'showPrice5'
    }
  };
  private specialTypeOfPrices = {
    useConferencePrice: {
      text: "Precio Conferencia (N1)",
      model: false,
      typeOfPrice: TypeOfPrice.Conference,
      show: 'showConference'
    },
    useCoursePrice: {
      text: "Precio Curso",
      model: true,
      typeOfPrice: TypeOfPrice.Course,
      show: 'showCourse'
    },
    useWebPrice: {
      text: "Precio Web (N1)",
      model: false,
      typeOfPrice: TypeOfPrice.Web,
      show: 'showWeb'
    },
    useBasePrice: {
      text: "Precio Base",
      model: false,
      typeOfPrice: TypeOfPrice.Base,
      show: 'showBase'
    },
    useRepeatPrice: {
      text: "Precio de Repetición",
      model: false,
      typeOfPrice: TypeOfPrice.Repeat,
      show: 'showRepeat'
    },
    useFusionPrice: {
      text: "Precio de Fusión",
      model: false,
      typeOfPrice: TypeOfPrice.Fusion,
      show: 'showFusion'
    },
    useWebinarPrice: {
      text: "Precio de Webinario",
      model: false,
      typeOfPrice: TypeOfPrice.Webinar,
      show: 'showWebinar'
    },
    useTlpPrice: {
      text: "Precio de TLP",
      model: false,
      typeOfPrice: TypeOfPrice.Tlp,
      show: 'showTlp'
    },
    usePwpPrice: {
      text: "Precio de PWP",
      model: false,
      typeOfPrice: TypeOfPrice.Pwp,
      show: 'showPwp'
    },
    usePPagoPrice: {
      text: "Precio de Pronto pago",
      model: false,
      typeOfPrice: TypeOfPrice.PPago,
      show: 'showP_pago'
    },
    useShuttlePrice: {
      text: "Precio de Lanzadera",
      model: false,
      typeOfPrice: TypeOfPrice.Shuttle,
      show: 'showShuttle'
    },
    useAmbassadorPrice: {
      text: "Precio de Embajadores",
      model: false,
      typeOfPrice: TypeOfPrice.Ambassador,
      show: 'showAmbassador'
    },
    useCn3Price: {
      text: "Precio de CN3",
      model: false,
      typeOfPrice: TypeOfPrice.Cn3,
      show: 'showCn3'
    }
  };

  @Watch("currentPurchase")
  watchCurrentPurchase() {
    this.setCurrentTypeOfPrice();
  }

  @Watch("clientSelected")
  watchClientSelected(newVal: any, oldVal: any) {
    if (!newVal) {
      this.searchString = "";
    }
  }

  private get specialPrices() {
    return this.specialAnnouncement || this.courseType
      ? this.specialTypeOfPrices
      : {};
  }

  private get specialAnnouncement() {
    return this.$route.query.specialAnnouncement;
  }

  private get courseType() {
    const type = `${this.$route.query["type-of-product"] || -100}`;
    return parseInt(type) === TypeOfProduct.Course;
  }

  private get priceType(): any {
    return { ...this.specialPrices, ...this.commonTypeOfPrices };
  }

  private get secondaryColor() {
    return this.specialAnnouncement ? "color-white" : "color-secondary";
  }

  get disabledComponent() {
    return this.purchaseFinished;
  }

  private get voucherNumber() {
    return this.currentPurchase.voucherNumber;
  }

  private setCurrentTypeOfPrice() {
    if (this.disabledComponent) {
      const firstLine = this.currentPurchase.purchaseLines[0] || {};
      if (firstLine.useBonoPrice) {
        this.resetRatioButton("useBonoPrice");
      } else if (firstLine.useConferencePrice) {
        this.resetRatioButton("useConferencePrice");
      } else if (firstLine.useCoursePrice) {
        this.resetRatioButton("useCoursePrice");
      } else if (firstLine.useWebPrice) {
        this.resetRatioButton("useWebPrice");
      } else if (firstLine.useBasePrice) {
        this.resetRatioButton("useBasePrice");
      } else if (firstLine.repeater) {
        this.resetRatioButton("useRepeatPrice");
      } else if (firstLine.useFusion) {
        this.resetRatioButton("useFusionPrice");
      } else if (firstLine.useWebinar) {
        this.resetRatioButton("useWebinarPrice");
      } else if (firstLine.useTlp) {
        this.resetRatioButton("useTlpPrice");
      } else if (firstLine.usePwp) {
        this.resetRatioButton("usePwpPrice");
      } else if (firstLine.usePPago) {
        this.resetRatioButton("usePPagoPrice");
      } else if (firstLine.useShuttle) {
        this.resetRatioButton("useShuttlePrice");
      } else if (firstLine.useAmbassador) {
        this.resetRatioButton("useAmbassadorPrice");
      } else if (firstLine.useCn3) {
        this.resetRatioButton("useCn3Price");
      }
    }
  }

  public resetRatioButton(key: string) {
    const obj: any = {
      ...this.priceType,
      useBonoPrice: this.useBonoPrice
    };
    Object.keys(obj).forEach((e: string) => {
      obj[e].model = e === key;
    });
    this.$store.dispatch("setTypeOfPrice", obj[key].typeOfPrice);
  }

  private get ownerText() {
    try {
      return this.currentPurchase.voucherOwner.user.fullName;
    } catch (_) {
      return "";
    }
  }

  private set voucherNumber(value: string | null) {
    this.currentPurchase.voucherNumber = value;
    this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
  }

  private get voucherOwner() {
    return this.currentPurchase.voucherOwner;
  }

  private set voucherOwner(owner: any | null) {
    try {
      this.currentPurchase.voucherOwner = this.getClient(owner.id);
      this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
    } catch (_) {
      this.currentPurchase.voucherOwner = null;
      this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
    }
  }

  private ratioAction(key: string) {
    const obj: any = {
      ...this.priceType,
      useBonoPrice: this.useBonoPrice
    };
    if (obj[key].model || this.disabledComponent) {
      return;
    }
    this.resetRatioButton(key);
  }

  private selectVoucherOwner(owner: any): void {
    this.voucherOwner = owner;
  }

  get showClientTags() {
    return this.clientSelectedTags && this.clientSelectedTags.length > 0;
  }

  get subtitleClass() {
    return this.specialAnnouncement ? "color-white" : "color-secondary";
  }

  get searchAutocompletePlaceholder() {
    return this.specialAnnouncement ? "Buscar" : "Busca un cliente";
  }

  get getClientList() {
    return this.voucherOwner ? [] : this.clientList;
  }

  private fetchClientList() {
    const payload = {
      limit: 20,
      search: this.searchString
    };
    this.$store.dispatch("fetchClientList", payload);
  }

  public searchCallback() {
    if (this.searchString === "") {
      this.voucherOwner = null;
    }
    this.fetchClientList();
  }

  private clearVoucherOwner() {
    this.voucherOwner = null;
  }
}
